interface FilterProps {
    className?: string;
}

export default function Filter({ className = "h-5 w-5" }: FilterProps) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M6 9L20.4 25.8178V38.4444L27.6 42V25.8178L42 9H6Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinejoin="round"
            />
        </svg>
    );
}
